<div *ngIf="!isLoading && !hasErrors">
	<div class="contact-baseline-wrapper zk-gap-5">
		<contact-baseline
			class="zk-flex-1"
			[baseline]="contactFollowUpInfo.baseline"
			[type]="contactFollowUpInfo.type"
		></contact-baseline>
		<contact-main-reasons
			class="zk-flex-1"
			[mainReasons]="contactFollowUpInfo.topReasons"
		></contact-main-reasons>
	</div>
	<contact-severity-chart
		class="zk-mt-5 zk-block"
		[type]="contactFollowUpInfo.type ? contactFollowUpInfo.type : 'CGI'"
		[severityResults]="contactFollowUpInfo.results"
		(goToPromptuaries)="goToPromptuaries.emit()"
	></contact-severity-chart>
</div>

<contact-moodtracker
	class="zk-mt-5"
	[firstName]="contact ? contact.displayName.split(' ', 1)[0] : ''"
	[contact]="contact"
	[professionalId]="professionalId"
></contact-moodtracker>
